export enum UserStatus {
    ACTIVE = 1,
    INACTIVE = 2,
    DENIED = 3
}

export enum UserDateType{
  REGISTRATION = 1,
  LAST_LOGIN = 2,
}
